/**
 * Neutral audio-feedback output node. The voice-core library ships a
 * do-nothing feedback sink so `audio/graph.ts` has no dependency on any
 * consumer's presentation code (see refactor_plan A.2 "Invert feedback
 * wiring"). Consumers that want audible feedback (e.g. Beatbox Hero's
 * Sonifier) construct their own node and connect it to the graph's output.
 */
export class Sonifier {
    constructor(ctx) {
        Object.defineProperty(this, "output", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.output = ctx.createGain();
        this.output.gain.value = 0;
    }
    dispose() {
        try {
            this.output.disconnect();
        }
        catch { }
    }
}
